import ActionMetaBuilder from 'storeState/ActionMetaBuilder';

export const PREFIX = "AUTH";

export const actionMeta = new ActionMetaBuilder(PREFIX);

actionMeta.defineRequest({
  name: "request_email_verification",
  urlBuilder: () => 'auth/request_email_verification'
});

actionMeta.defineRequest({
  name: "registration",
  urlBuilder: () => 'auth/registration'
});

actionMeta.defineOther({
    name: "registration_reset",
});

actionMeta.defineRequest({
  name: "login",
  urlBuilder: () => 'auth/login'
});

actionMeta.defineRequest({
  name: "logout",
  urlBuilder: () => 'auth/logout'
});

actionMeta.defineRequest({
  name: "validate_email",
  urlBuilder: () => 'auth/validate_email'
});

actionMeta.defineRequest({
  name: "validate_username",
  urlBuilder: () => 'auth/validate_username'
});

actionMeta.defineRequest({
  name: "validate_password",
  urlBuilder: () => 'auth/validate_password'
});

actionMeta.defineRequest({
  name: "request_password_reset",
  urlBuilder: () => 'auth/request_password_reset'
});

actionMeta.defineRequest({
  name: "confirm_password_reset",
  urlBuilder: () => 'auth/confirm_password_reset'
});

actionMeta.defineOther({
    name: "set_current_tenant_id",
});


/*actionMeta.defineRequest({
    name: "users_list",
    urlBuilder: () => `auth/users`
});*/



// WEBPACK FOOTER //
// ./src/storeState/auth/meta.js